module.exports = __webpack_public_path__ + "static/media/gnb-logo.4906c216.svg";